var render = function render(){var _vm=this,_c=_vm._self._c;return _c('page',{attrs:{"title":_vm.i18n.download}},[_c('div',{staticClass:"download-content"},[_c('div',{staticClass:"tips"},[_vm._v(_vm._s(_vm.i18n.download_tips))]),_c('div',{staticClass:"downloadbtn btn",on:{"click":_vm.onDownload}},[_c('span',[_vm._v(_vm._s(_vm.i18n.download))])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }